import { all } from "redux-saga/effects";
import { watchLoginSaga } from "./auth/authSaga";
import { watchAssignedBookings } from "./booking/bookingSaga";
import { watchDriverAsync } from "./driver/driverSaga";

export function* rootSaga() {
  yield all([watchLoginSaga(), watchAssignedBookings(), watchDriverAsync()]);
}
